<template>
    <div class=" card-body" v-if="isMounted">
        <el-row :gutter="20">
            <el-col :span="8">
                <span>回访日期：</span>
                <el-date-picker
                        v-model="$parentInfo.pastReturnVisit.form.complaintsDate"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        @change="handleShowReturnVisit()"
                        style="width: 150px">
                </el-date-picker>
            </el-col>
            <el-col :span="8">
                <span>拨号人：</span>
                <el-select v-model="$parentInfo.pastReturnVisit.form.returnVisitor"
                           remote clearable
                           :remote-method="handleSearchHeadTeacher"
                           @change="handleShowReturnVisit()"
                           filterable placeholder="拨号人"
                           style="width: 150px">
                    <el-option
                            v-for="item in $parentInfo.headTeachers"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
            <el-col :span="8">
                <span>家长：</span>
                <el-select v-model="$parentInfo.pastReturnVisit.form.parentsName"
                           clearable
                           placeholder="请输入家长姓名"
                           @change="handleShowReturnVisit()"
                           style="width: 150px">
                    <el-option
                            v-for="item in $parentInfo.beReturn"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>
        <div  v-loading="$parentInfo.pastReturnVisit.loading">
            <el-table
                    :data="returnVisit_order"
                    style="width: 100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left" inline class="demo-table-expand" label-width="120px" v-if="!props.row.problemAndAnswer">
                            <el-form-item label="家长反馈">
                                <span>{{ props.row.return_visit_opinion }}</span>
                            </el-form-item>
                            <el-form-item label="家长建议">
                                <span>{{ props.row.attributeOpinion }}</span>
                            </el-form-item>
                            <el-form-item label="卖课反馈">
                                <span>{{ props.row.sellClassFeedback }}</span>
                            </el-form-item>
                            <el-form-item label="回访备注">
                                <span>{{ props.row.remark }}</span>
                            </el-form-item>
                        </el-form>

                        <el-form label-position="top" v-else>
                            <div v-for="(item,index) in props.row.problemAndAnswer" :key="index">
                                <div style="font-size: 20px">
                                    {{item.title}}
                                </div>
                                <el-form-item v-for="(item1,index1) in item.content" :label="item1.problem" :key="index1">
                                    <el-input
                                            type="textarea"
                                            :autosize="{ minRows: 2, maxRows: 20}"
                                            placeholder=""
                                            disabled
                                            v-model="item1.content"
                                    >
                                    </el-input>
                                </el-form-item>
                            </div>

                        </el-form>

                    </template>
                </el-table-column>
                <el-table-column
                        label="回访时间"
                        prop="return_date">
                </el-table-column>
                <el-table-column
                        label="拨号人"
                        prop="headTeacher_name">
                    <template slot-scope="scope">
                        <span v-if="scope.row.headTeacher_name">{{scope.row.headTeacher_name}}</span>
                        <span v-else>数据缺失</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="被回访人">
                    <template slot-scope="scope">
                        <span v-if="scope.row.parent_name"> 家长：{{scope.row.parent_name}}</span>
                        <span v-else> 学生：{{$parentInfo.student.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="联系方式"
                        prop="contact">
                </el-table-column>
                <el-table-column
                        label="开始回访时间"
                        prop="created_at">
                </el-table-column>
                <el-table-column
                        label="回访时长"
                        prop="return_time">
                </el-table-column>
            </el-table>
        </div>

        <!--分页-->
        <div class="text-center m-t-10">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="$parentInfo.pastReturnVisit.currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="$parentInfo.pastReturnVisit.total">
            </el-pagination>
        </div>
        <el-dialog title="回访详情" :visible.sync="$parentInfo.pastReturnVisit.visualDetail" width="600px">
            <div>
                <span>回访家长的意见:<br>{{$parentInfo.pastReturnVisit.detailData.return_visit_opinion}}</span>
            </div>
            <div>
                <span>回访家长的态度:<br>{{$parentInfo.pastReturnVisit.detailData.attributeOpinion}}</span>
            </div>
            <div>
                <span>备注:<br>{{$parentInfo.pastReturnVisit.detailData.remark}}</span>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    export default {
        name: "PastReturnVisit",
        data() {
            return {
                isMounted:false,
            }
        },
        computed: {
            returnVisit_order: function () {
                return this._.orderBy(this.$parentInfo.pastReturnVisit.returnVisit, 'id','desc');
            }
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowReturnVisit();
            this.isMounted=true;
        },
        methods: {
            handleShowReturnVisit(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.$parentInfo.path, 'past_returnVisit',
                    {'currentPage':currentPage,'currentPageSize':currentPageSize,'student_id':this.$parentInfo.student_id,'form':this.$parentInfo.pastReturnVisit.form})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleShowReturnVisit(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleShowReturnVisit(this.currentPage, this.currentPageSize)
            },
            handleCheckReturn(id) {
                this.$wApi.send(this.$parentInfo.path, 'check_return', {'id':id});
            },
            handleSearchHeadTeacher(query){
                this.$wApi.send(this.$parentInfo.path, 'search_headTeacher', {'headTeacherName':query})
            },
        }
    }
</script>

<style>
    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>